import React from 'react';
import PropTypes from 'prop-types';
import './Card.css';

const Card = ({ 
  children, 
  variant = 'default', 
  hover = false, 
  glow = false,
  className = '',
  onClick,
  tabIndex,
  role,
  ariaLabel,
  ...props 
}) => {
  const cardClass = `card card--${variant} ${hover ? 'card--hover' : ''} ${glow ? 'card--glow' : ''} ${className}`.trim();

  const cardProps = {
    className: cardClass,
    onClick,
    tabIndex: onClick ? (tabIndex || 0) : undefined,
    role: onClick ? (role || 'button') : role,
    'aria-label': ariaLabel,
    onKeyDown: onClick ? (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick(e);
      }
    } : undefined,
    ...props
  };

  return (
    <div {...cardProps}>
      {children}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'dark', 'glass', 'gradient']),
  hover: PropTypes.bool,
  glow: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  tabIndex: PropTypes.number,
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export default Card;